<template>
	<div>
		<div class="row">
			<div v-if="showTitle" class="col-md-12 mb-1 d-flex align-items-center justify-content-center">
					<h5>{{ tabTitle }}</h5>

				<div class="ml-auto">

					<el-checkbox border size="small" class="me-2" v-model="showchart" v-show="tabName =='sales' ">
						Show Chart
					</el-checkbox>

					<el-popover trigger="click" size="small" ref="dropdown" v-model="dropdownVisible" popper-class="dropdown-filter">
						<el-button slot="reference" type="primary" plain size="small">
							<i class="fa fa-filter"></i> &nbsp; Filter
						</el-button>
						<div>
							<div class="ps-3 pe-3 pt-1 pb-1">
								<h5><i class="fa fa-filter"></i> &nbsp; Filter {{ tabLabel }}</h5>
							</div>
							<el-divider class="m-0"></el-divider>
							<div class="dropdown-filter-form">
								<el-form label-position="top" label-width="100px" v-on:change="resumePilihan">
									<div class="row">
										<div class="col-md-6" v-show="tabName != 'absen' && tabName != 'stock_kemasan' && tabName != 'sales_kemasan' ">
											<el-form-item label="Station">
												<el-radio-group v-model="detail1" size="small">
													<el-radio-button name="detail1" :label="item1.value" v-for="(item1, index1) in options.detail1" :key="item1.value+'_'+index1" style="margin-left:0px;">{{item1.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
										<div class="col-md-6">
											<el-form-item label="Search">
												<el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
													<el-option v-for="item7 in spbu.list" :key="item7.StationId" :label="item7.StationName" :value="item7.StationId">
													</el-option>
												</el-select>
											</el-form-item>
											<!--<ReportParamSearch title="Search" v-model="stationid" :options="spbu.list" fldid="StationId" fldinfo="StationName" />-->
										</div>
										<div class="col-md-6" v-if="tabName == 'sales_kemasan'">
											<el-form-item label="Branch">
												<el-select v-model="branchid" clearable filterable placeholder="Select Branch" size="small" style="width:100%;">
													<el-option v-for="item7 in options.branchlist" :key="item7.BranchID" :label="item7.BranchName" :value="item7.BranchID">
													</el-option>
												</el-select>
											</el-form-item>
										</div>

										<div class="col-md-6" v-show="tabName != 'stock' && tabName != 'stock_kemasan' ">
											<el-form-item label="Date" style="max-width: 250px;">
												<el-date-picker
													size="small"
													v-model="date"
													type="daterange"
													align="right"
													format="yyyy-MM-dd"
													value-format="yyyy-MM-dd"
													>
													<!--
													:start-placeholder="date.Start"
													:end-placeholder="date.End"
													:default-value="date.End"
													-->
												</el-date-picker>
											</el-form-item>

											<!--<ReportParamDateRange title="Date" v-model="date" />-->
										</div>
										<!--
										<div class="col-md-6 form-group" v-if="tabIndex<4">
											<ReportParamSelect title="Periods" name="period" v-model="period" :options="options.period" />
										</div>
										-->

										<div class="col-md-6" v-show="is2024OrBelow && tabName != 'absen' && tabName != 'stock_kemasan' && tabName != 'sales_kemasan' ">
											<el-form-item label="Area">
												<el-radio-group v-model="area" size="small">
													<el-radio-button name="area" :label="item2.value" v-for="(item2, index2) in options.area" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
											<!--<ReportParamSelect title="Area" name="area" v-model="area" :options="options.area" />-->
										</div>
										<div class="col-md-6" v-show="is2025OrAbove && tabName != 'absen' && tabName != 'stock_kemasan' && tabName != 'sales_kemasan' ">
											<el-form-item label="Region">
												<el-radio-group v-model="region" size="small">
													<el-radio-button name="region" :label="item2.value" v-for="(item2, index2) in options.region" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
											<!--<ReportParamSelect title="Area" name="area" v-model="area" :options="options.area" />-->
										</div>
										<!--
										<div class="col-md-4 form-group">
											<ReportParamSelect title="Owner" name="owner" v-model="owner" :options="options.owner" />
										</div>-->
										<div class="col-md-6" v-show="tabName != 'absen' && tabName != 'stock_kemasan' && tabName != 'sales_kemasan' ">
											<el-form-item label="Tol">
												<el-radio-group v-model="lokasi" size="small">
													<el-radio-button name="lokasi" :label="item3.value" v-for="(item3, index3) in options.lokasi" :key="item3.value+'_'+index3" style="margin-left:0px;">{{item3.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
											<!--<ReportParamSelect title="Tol" name="lokasi" v-model="lokasi" :options="options.lokasi" />-->
										</div>

										<div class="col-md-6" v-if="tabName == 'sales_kemasan'">
											<el-form-item label="Item Name">
												<el-select v-model="itemname" clearable filterable placeholder="Select Item Name" size="small" style="width:100%;">
													<el-option v-for="item8 in options.itemlist" :key="item8.ItemID" :label="item8.ItemName" :value="item8.ItemID">
													</el-option>
												</el-select>
											</el-form-item>
										</div>

										<div class="col-md-6" v-show="tabName != 'payment' && tabName != 'absen' && tabName != 'stock_kemasan' && tabName != 'sales_kemasan'">
											<el-form-item label="Products">
												<el-radio-group v-model="detail2" size="small">
													<el-radio-button name="detail2" :label="item4.value" v-for="(item4, index4) in options.detail2" :key="item4.value+'_'+index4" style="margin-left:0px;">{{item4.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
											<!--<ReportParamSelect title="Products" name="detail2" v-model="detail2" :options="options.detail2" />-->
										</div>
										<div class="col-md-6" v-show="tabName == 'payment'">
											<el-form-item label="Payment">
												<el-radio-group v-model="detail3" size="small">
													<el-radio-button name="detail3" :label="item5.value" v-for="(item5, index5) in options.detail3" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
											<!--<ReportParamSelect title="Payment" name="detail3" v-model="detail3" :options="options.detail3" />-->
										</div>
										<div class="col-md-6" v-show="tabName == 'stock' || tabName == 'stock_kemasan'">
											<el-form-item label="Status">
												<el-radio-group v-model="status" size="small">
													<el-radio-button name="status" :label="item6.value" v-for="(item6, index6) in options.status" :key="item6.value+'_'+index6" style="margin-left:0px;">{{item6.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
											<!--<ReportParamSelect title="Status" name="status" v-model="status" :options="options.status" />-->
										</div>

										<div class="col-md-6" v-show="tabName == 'absen'">
											<el-form-item label="Job Position">
												<el-select v-model="job" clearable filterable placeholder="Select Job" size="small" style="width:100%;">
													<el-option v-for="item7 in options.job" :key="item7.value" :label="item7.name" :value="item7.value">
													</el-option>
												</el-select>
											</el-form-item>
											<!--<ReportParamSearch title="Search" v-model="stationid" :options="spbu.list" fldid="StationId" fldinfo="StationName" />-->
										</div>

										<div class="col-md-6" v-show="tabName == 'absen'">
											<el-form-item label="Vendor">
												<el-select v-model="vendor" clearable filterable placeholder="Select Vendor" size="small" style="width:100%;">
													<el-option v-for="item7 in options.vendor" :key="item7.value" :label="item7.name" :value="item7.value">
													</el-option>
												</el-select>
											</el-form-item>
											<!--<ReportParamSearch title="Search" v-model="stationid" :options="spbu.list" fldid="StationId" fldinfo="StationName" />-->
										</div>

										<div class="col-md-6" v-show="tabName == 'absen'">
											<el-form-item label="Condition">
												<el-radio-group v-model="condition" size="small">
													<el-radio-button name="condition" :label="item4.value" v-for="(item4, index4) in options.condition" :key="item4.value+'_'+index4" style="margin-left:0px;">{{item4.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
											<!--<ReportParamSelect title="Products" name="detail2" v-model="detail2" :options="options.detail2" />-->
										</div>

									</div>
								</el-form>
							</div>
							<el-divider class="m-0"></el-divider>
							<div class="py-2 px-4">
								<div class="row">
									<div class="col-md-12 d-flex align-items-center">
										<div class="ml-auto">
											<el-button type="danger" size="medium" @click="closeDropdownForm" style="min-width:100px;"><i class="fa fa-close"></i> &nbsp; Close</el-button>
											<el-button type="primary" size="medium" :loading="loading.table" @click="resumePilihan" style="min-width:100px;"><i class="fa fa-check"></i> &nbsp; Apply Filter</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-popover>

					<el-button class="ms-2" type="success" plain size="small" @click="exportExcel()" v-if="reportdata?.data?.length">
						<i class="fa fa-file-excel"></i> &nbsp; Export
					</el-button>
					<vue-excel-xlsx
						v-show="false"
						ref="excelExport"
						:data="dataXLSX(reportdata)"
						:columns="columnXLSX(reportdata)"
						:file-name="'Satgas ' + tabLabel"
						:file-type="'xlsx'"
						:sheet-name="'sheet1'"
						>
						<i class="far fa-file-excel"></i>
					</vue-excel-xlsx>

				</div>
			</div>

			<div class="col-md-12" v-if="!showTitle">
                <el-collapse>
                    <el-collapse-item>
                        <template slot="title">
                            <span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
                        </template>
                        <el-form label-position="top" label-width="100px" v-on:change="resumePilihan">
                            <div class="row">
                                <div class="col-md-5" v-show="tabName != 'absen' && tabName != 'stock_kemasan' && tabName != 'sales_kemasan' ">
                                    <el-form-item label="Station">
                                        <el-radio-group v-model="detail1" size="small">
                                            <el-radio-button name="detail1" :label="item1.value" v-for="(item1, index1) in options.detail1" :key="item1.value+'_'+index1" style="margin-left:0px;">{{item1.name}}</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item>
                                </div>
                                <div class="col-md-7">
                                    <el-form-item label="Search">
                                        <el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
                                            <el-option v-for="item7 in spbu.list" :key="item7.StationId" :label="item7.StationName" :value="item7.StationId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <!--<ReportParamSearch title="Search" v-model="stationid" :options="spbu.list" fldid="StationId" fldinfo="StationName" />-->
                                </div>
								<div class="col-md-5" v-if="tabName == 'sales_kemasan'">
                                    <el-form-item label="Branch">
                                        <el-select v-model="branchid" clearable filterable placeholder="Select Branch" size="small" style="width:100%;">
                                            <el-option v-for="item7 in options.branchlist" :key="item7.BranchID" :label="item7.BranchName" :value="item7.BranchID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5" v-show="tabName != 'absen' && tabName != 'stock_kemasan' && tabName != 'sales_kemasan' ">
                                    <el-form-item label="Area">
                                        <el-radio-group v-model="area" size="small">
                                            <el-radio-button name="area" :label="item2.value" v-for="(item2, index2) in options.area" :key="item2.value+'_'+index2" style="margin-left:0px;">{{item2.name}}</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item>
                                    <!--<ReportParamSelect title="Area" name="area" v-model="area" :options="options.area" />-->
                                </div> <!--
                                <div class="col-md-4 form-group">
                                    <ReportParamSelect title="Owner" name="owner" v-model="owner" :options="options.owner" />
                                </div>-->
                                <div class="col-md-7" v-show="tabName != 'absen' && tabName != 'stock_kemasan' && tabName != 'sales_kemasan' ">
                                    <el-form-item label="Tol">
                                        <el-radio-group v-model="lokasi" size="small">
                                            <el-radio-button name="lokasi" :label="item3.value" v-for="(item3, index3) in options.lokasi" :key="item3.value+'_'+index3" style="margin-left:0px;">{{item3.name}}</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item>
                                    <!--<ReportParamSelect title="Tol" name="lokasi" v-model="lokasi" :options="options.lokasi" />-->
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5" v-show="tabName != 'stock' && tabName != 'stock_kemasan' ">
                                    <el-form-item label="Date">
                                        <el-date-picker
                                            size="small"
                                            v-model="date"
                                            type="daterange"
                                            align="right"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            >
                                            <!--
                                            :start-placeholder="date.Start"
                                            :end-placeholder="date.End"
                                            :default-value="date.End"
                                            -->
                                        </el-date-picker>
                                    </el-form-item>

                                    <!--<ReportParamDateRange title="Date" v-model="date" />-->
                                </div>
								<!--
                                <div class="col-md-6 form-group" v-if="tabIndex<4">
                                    <ReportParamSelect title="Periods" name="period" v-model="period" :options="options.period" />
                                </div>
								-->

								<div class="col-md-5" v-if="tabName == 'sales_kemasan'">
                                    <el-form-item label="Item Name">
                                        <el-select v-model="itemname" clearable filterable placeholder="Select Item Name" size="small" style="width:100%;">
                                            <el-option v-for="item8 in options.itemlist" :key="item8.ItemID" :label="item8.ItemName" :value="item8.ItemID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>

                                <div class="col-md-5" v-show="tabName != 'payment' && tabName != 'absen' && tabName != 'stock_kemasan' && tabName != 'sales_kemasan'">
                                    <el-form-item label="Products">
                                        <el-radio-group v-model="detail2" size="small">
                                            <el-radio-button name="detail2" :label="item4.value" v-for="(item4, index4) in options.detail2" :key="item4.value+'_'+index4" style="margin-left:0px;">{{item4.name}}</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item>
                                    <!--<ReportParamSelect title="Products" name="detail2" v-model="detail2" :options="options.detail2" />-->
                                </div>
                                <div class="col-md-5" v-show="tabName == 'payment'">
                                    <el-form-item label="Payment">
                                        <el-radio-group v-model="detail3" size="small">
                                            <el-radio-button name="detail3" :label="item5.value" v-for="(item5, index5) in options.detail3" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item>
                                    <!--<ReportParamSelect title="Payment" name="detail3" v-model="detail3" :options="options.detail3" />-->
                                </div>
                                <div class="col-md-5" v-show="tabName == 'stock' || tabName == 'stock_kemasan'">
                                    <el-form-item label="Status">
                                        <el-radio-group v-model="status" size="small">
                                            <el-radio-button name="status" :label="item6.value" v-for="(item6, index6) in options.status" :key="item6.value+'_'+index6" style="margin-left:0px;">{{item6.name}}</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item>
                                    <!--<ReportParamSelect title="Status" name="status" v-model="status" :options="options.status" />-->
                                </div>

								<div class="col-md-5" v-show="tabName == 'absen'">
                                    <el-form-item label="Condition">
                                        <el-radio-group v-model="condition" size="small">
                                            <el-radio-button name="condition" :label="item4.value" v-for="(item4, index4) in options.condition" :key="item4.value+'_'+index4" style="margin-left:0px;">{{item4.name}}</el-radio-button>
                                        </el-radio-group>
                                    </el-form-item>
                                    <!--<ReportParamSelect title="Products" name="detail2" v-model="detail2" :options="options.detail2" />-->
                                </div>

								<div class="col-md-5" v-show="tabName == 'absen'">
                                    <el-form-item label="Job Position">
                                        <el-select v-model="job" clearable filterable placeholder="Select Job" size="small" style="width:100%;">
                                            <el-option v-for="item7 in options.job" :key="item7.value" :label="item7.name" :value="item7.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <!--<ReportParamSearch title="Search" v-model="stationid" :options="spbu.list" fldid="StationId" fldinfo="StationName" />-->
                                </div>

								<div class="col-md-5" v-show="tabName == 'absen'">
                                    <el-form-item label="Vendor">
                                        <el-select v-model="vendor" clearable filterable placeholder="Select Vendor" size="small" style="width:100%;">
                                            <el-option v-for="item7 in options.vendor" :key="item7.value" :label="item7.name" :value="item7.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <!--<ReportParamSearch title="Search" v-model="stationid" :options="spbu.list" fldid="StationId" fldinfo="StationName" />-->
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-5 mt-2">
                                    <el-button type="success" size="medium" :loading="loading" @click="resumePilihan" style="width:100%;">Apply Filter</el-button>
                                </div>
                            </div>

                        </el-form>
                    </el-collapse-item>
                </el-collapse>
			</div>
		</div>

        <div class="row mt-1" v-if="tabName=='sales'">
            <div class="col-md-6" v-if="false"><el-checkbox v-model="showchart">Show Chart</el-checkbox></div>
            <div class="col-md-4 mb-1 me-4" v-if="showchart">
                <el-radio-group v-model="charttype">
                    <el-radio label="barchart" size="small">Bar Chart</el-radio>
                    <el-radio label="linechart" size="small">Line Chart</el-radio>
                </el-radio-group>
            </div>
			<div class="col-md-1 me-4" v-if="showchart && charttype=='barchart'"><el-checkbox v-model="stacked">Stacked</el-checkbox> </div>
			<div class="col-md-1" v-if="showchart"><el-checkbox v-model="showValue">Show Value</el-checkbox> </div>
        </div>
		<div class="row mt-1 mb-0" v-if="tabName=='sales'">
			<div class="col-md-12 mb-3" v-if="showchart && tabName=='sales'">
				<el-radio-group v-model="salescharttype">
					<!--<el-radio label="saleschartall" size="small">All</el-radio> -->
					<el-radio label="saleschartproduct" size="small">By Product</el-radio>
					<el-radio label="saleschartarea" size="small">By Area</el-radio>
					<el-radio label="saleschartregion" size="small">By Region</el-radio>
					<el-radio label="saleschartsalesvsstock" size="small">Sales VS Stock Volume (KL)</el-radio>
				</el-radio-group>
			</div>
		</div>

		<BarChart class="mb-3" v-loading.body="loading" :data="chartdata" :width="500" :height="350" v-if="showchart && tabName=='sales' && charttype=='barchart'"  :showValue="showValue"/>
		<LineChart class="mb-3" v-loading.body="loading" :data="chartdata" :width="500" :height="350" v-if="showchart && tabName=='sales' && charttype=='linechart'" :showValue="showValue" />

		<div class="row">
			<div class="col-md-12 mx-auto">
				<div class="h-100 d-flex align-items-center justify-content-center">
					<ReportResultTable reportname="SatgasReport" :reportdata="reportdata" :reporturl="urlRequestParams" :loading="loading" />
					<!--<Loader :loading="loading" :color="'#007ACC'" :customclass="''" class="child"/>-->
				</div>
			</div>
		</div>

	</div>
</template>

<script>

import Fuel from '@/components/page/Fuel.js'
import BarChart from '@/components/chart/BarChart2.js'
import LineChart from '@/components/chart/LineChart2.js'
import ReportParamSearch from '@/views/pages/ReportParamSearch.vue'
import ReportParamDateRange from '@/views/pages/ReportParamDateRange.vue'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2Custom.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
//import Loader from '@/components/loader/Loader.vue'

export default
{
	extends:Fuel,
    props: ['tabIndex','tabName', 'tabLabel', 'tabTitle', 'showTitle'],
	components: {
		LineChart,
        BarChart,
		//ReportParamSelect,
		ReportResultTable,
		//ReportParamSearch,
		//ReportParamDateRange,
		//Loader,
	},
	data() {
		return {
            /*
			date: {
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : '2022-12-01',//Penanggalan().mingguSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : '2023-01-31',//Penanggalan().kemarin,
			},*/
            date: [this.$route.query['date-range-start'] ? this.$route.query['date-range-start'] : Penanggalan().tahunSekarang, this.$route.query['date-range-end'] ? this.$route.query['date-range-end'] : Penanggalan().kemarin],
			urlRequestParams: '',
			options: {
				period:[
					{ value: '', name: 'ALL' },
					{ value: 'daily', name: 'DAILY' },
					{ value: 'monthly', name: 'MONTHLY'  },
					{ value: 'yearly', name: 'YEARLY' },
				],
				detail1:[
					{ value: "", name: "ALL" },
					{ value: "station", name: "BY STATION" },
					{ value: "tank", name: "BY TANK" },
				],
				detail2:[
					{ value: "", name: "ALL" },
					{ value: "group", name: "BY GROUP", field: "ProductGroup" },
					{ value: "product", name: "BY PRODUCT", field: "ProductName" },
				],
				detail3:[
					{ value: "", name: "ALL" },
					{ value: "cash", name: "BY CASH" },
					{ value: "payment", name: "BY METHOD" },
				],
				area:[
					{ value: "", name: "ALL" },
					{ value: "area", name: "BY AREA", field: "SalesArea" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
				],
				region:[
					{ value: "", name: "ALL" },
					{ value: "region", name: "BY REGION", field: "RegionPertareId" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
					{ value: "6", name: "6" },
					{ value: "7", name: "7" },
				],
				owner:[
					{ value: "", name: "ALL" },
					{ value: "COCO", name: "COCO" },
					{ value: "KSO", name: "KSO" },
					{ value: "TAC", name: "TAC" },
				],
				lokasi:[
					{ value: "", name: "ALL" },
					{ value: "TOL", name: "TOL" },
					{ value: "NON TOL", name: "NON TOL" },
				],
				status:[
					{ value: "", name: "ALL" },
					{ value: "NORMAL", name: "NORMAL" },
					{ value: "LOW", name: "LOW" },
					{ value: "CRITICAL", name: "CRITICAL" },
				],
				condition:[
					{ value: "", name: "ALL" },
					{ value: "fit", name: "Fit" },
					{ value: "unfit", name: "Unfit" },
				],
				job:[
					{ value: "", name: "ALL" },
					{ value: "ADMHO01", name: "Admin Fuel" },
					{ value: "JOB-000001", name: "Pengawas" },
					{ value: "JOB-000002", name: "Kasir" },
					{ value: "JOB-000003", name: "Ka. Shift" },
					{ value: "JOB-000004", name: "Admin" },
					{ value: "JOB-000005", name: "Operator" },
					{ value: "JOB-000008", name: "Cleaning Service" },
					{ value: "JOB-000012", name: "Security" },
					{ value: "JOB-000020", name: "Teknisi" },
					{ value: "JOB-000023", name: "Site Supervisor" },
					{ value: "JOB-000054", name: "Pengawas Non Fuel" },
					{ value: "JOB-000056", name: "Ka. Shift Spbg" },
					{ value: "JOB-000057", name: "Operator Spbg" },
					{ value: "JOB-000095", name: "Pramuniaga" },
				],
				vendor:[
					{ value: "", name: "ALL" },
					{ value: "1", name: "PEKAGE" },
					{ value: "2", name: "KOPERTARE" },
				],

				//for bbk kemasan
				branchlist: [],
				itemlist: [],
				//end for bbk kemasan
			},
			tabList:[
				{name:'Sales'},
				{name:'Losses'},
				{name:'Payment'},
				{name:'Stock'},
				//{name:'shift'},
				//{name:'transaction'},
				//{name:'tank delivery'},
				//{name:'oil flow'},
			],
			//tabIndex: this.$route.query.tab ? this.$route.query.tab : 0,
			reportdata: [],
			chartdata: [],
			branchid: '',
			itemname: '',
			loading : true,
			showchart: this.$route.query.showchart ? this.$route.query.showchart : false,
			stacked: true,
			plantno: this.$route.query.plant ? this.$route.query.plant : '',
			stationid: this.$route.query.station ? this.$route.query.station : '',
			period: this.$route.query.period ? this.$route.query.period : 'daily',
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : 'station',
			detail2: this.$route.query.detail2 ? this.$route.query.detail2 : '',
			detail3: this.$route.query.detail3 ? this.$route.query.detail3 : '',
			area: this.$route.query.area ? this.$route.query.area : 'area',
			region: this.$route.query.region ? this.$route.query.region : 'region',
			owner: this.$route.query.owner ? this.$route.query.owner : '',
			lokasi: this.$route.query.lokasi ? this.$route.query.lokasi : '',
			status: this.$route.query.status ? this.$route.query.status : 'CRITICAL',
			condition: this.$route.query.condition ? this.$route.query.condition : '',
			job: this.$route.query.job ? this.$route.query.job : '',
			vendor: this.$route.query.vendor ? this.$route.query.vendor : '',

            showValue: false,
            charttype: 'barchart',
			is2024OrBelow: false,
			is2025OrAbove: true,
			dropdownVisible: false,
			filteredData2024AndBelow: [],
			filteredData2025AndAbove: [],
			salescharttype: 'saleschartarea', //saleschartall

		}
	},

	watch:
	{
		tabIndex() { this.resumePilihan() },
		//date(){ this.resumePilihan() },
		plantno() { this.resumePilihan() },
		//stationid() { this.resumePilihan() },
		reportdata() { this.refreshChart(); },
		stacked() { this.refreshChart(); },
		salescharttype() { this.refreshChart(); },
		date(newValue, oldValue) {
			let yearCategory = this.getYearCategory(newValue);
			// && is2024OrBelow
			if(yearCategory == 1) {
				//year 2025 or above
				this.is2025OrAbove = true;
				this.is2024OrBelow = false;

				this.region = 'region';
				this.area = '';
				this.salescharttype = 'saleschartregion'
			} else if(yearCategory == 2) {
				//year 2024 or below
				this.is2024OrBelow = true;
				this.is2025OrAbove = false;

				this.region = '';
				this.area = 'area';
				this.salescharttype = 'saleschartarea'
			} else {
				//year mixed
				this.is2024OrBelow = true;
				this.is2025OrAbove = true;

				this.region = 'region';
				this.area = 'area';
				this.salescharttype = 'saleschartregion' // 'saleschartall'
			}

			//console.log('area: ' + this.area);
			//console.log('region: ' + this.region);
		},
	},
	mounted(){
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
		document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
		this.$emit('childrenRoute')

		if(this.tabName == 'stock_kemasan') {
//			this.loadStationListKemasan()
		} else if(this.tabName == 'sales_kemasan') {
			//generate after load data
		} else {
//			this.loadStationList('satgas')
		}

		this.loadStationList('satgas')

		this.getSatgasDefaultConfig()
		this.getJobPosition()
		this.getVendor()
		//this.resumePilihan()

        if(this.showchart == '1')
            this.showchart = true
	},
	methods:{

		refreshChart() {
			let opt = this.getoption(this.detail2, this.options.detail2)
			let a = opt && opt.field ? opt.field : ""

			opt = this.getoption(this.area, this.options.area)
			a = opt && opt.field ? opt.field : a

			let b = "Period"
			let c = (a == "ProductName") ? FuelColor : Rainbow

			if(this.tabName == 'sales') {
				if(this.salescharttype == 'saleschartproduct') {
					this.chartdata = this.processBarChart(this.reportdata.data, "ProductName" , "", "SalesVolume", false, b, "", 1, 2, Rainbow, false, false, false, this.stacked);
					//console.log('chart all');
				} else if(this.salescharttype == 'saleschartarea') {
					this.chartdata = this.processBarChart(this.chartDataArea, "SalesArea", "AREA ", "SalesVolume", false, "Period", "", 1, 2, Rainbow, false, false, false, this.stacked);
					//console.log('chart area');
				} else if(this.salescharttype == 'saleschartregion') {
					this.chartdata = this.processBarChart(this.chartDataRegion, "RegionPertareId", "REGION ", "SalesVolume", false, b, "", 1, 2, Rainbow, false, false, false, this.stacked);
					//console.log('chart region');
				}  else if(this.salescharttype == 'saleschartsalesvsstock') {
					this.chartdata = this.processBarChart(this.chartDataSalesAndStock, "Legend", "", "Volume", false, b, "", 1, 2, Rainbow, false, false, false, this.stacked);
					//console.log('chart region');
				} else {
					this.chartdata = this.processBarChart(this.reportdata.data, "ProductName" , "", "SalesVolume", false, b, "", 1, 2, Rainbow, false, false, false, this.stacked);
					//console.log('chart all');
				}
			} else {
				this.chartdata = this.processBarChart(this.reportdata.data, a, "", "SalesVolume", false, b, "", 1000, 2, c, false, false, false, this.stacked);
			}
		},

		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')
		},

		async resumePilihan() {
			this.dropdownVisible = false;
			this.urlRequestParams=Config().apiURL
			if (this.tabName == 'sales') this.urlRequestParams+='/fuel2/sales?'
			else if (this.tabName == 'losses') this.urlRequestParams+='/fuel2/losses?'
			else if (this.tabName == 'payment') this.urlRequestParams+='/fuel2/payment?'
			else if (this.tabName == 'stock') this.urlRequestParams+='/fuel2/stock?'
			else if (this.tabName == 'absen') this.urlRequestParams+='/vendor/absentkjp?'

			else if (this.tabName == 'shift') this.urlRequestParams+='/plant/shift?'
			else if (this.tabName == 'transaction') this.urlRequestParams+='/plant/transaction?'
			else if (this.tabName == 'delivery') this.urlRequestParams+='/plant/delivery?'
			else if (this.tabName == 'stock_kemasan') this.urlRequestParams+='/fuel2/stock-kemasan?'
			else if (this.tabName == 'sales_kemasan') this.urlRequestParams+='/fuel2/sales-bbk-kemasan?'

			this.urlRequestParams+='&date-range-start='+ (this.date && this.date[0] ? this.date[0] : '') //this.date.Start
			this.urlRequestParams+='&date-range-end='+ (this.date && this.date[1] ? this.date[1] : '') //this.date[1] //this.date.End

			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&plant='+this.plantno
			this.urlRequestParams+='&station='+this.stationid
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&region='+this.region
			this.urlRequestParams+='&owner='+this.owner
			this.urlRequestParams+='&lokasi='+this.lokasi
			this.urlRequestParams+='&status='+this.status
			this.urlRequestParams+='&satgas=1'
			this.urlRequestParams+='&detail='+this.detail1 + '_' + this.detail2 + '_' + this.detail3
			this.urlRequestParams+='&job='+this.job
			this.urlRequestParams+='&condition='+this.condition
			this.urlRequestParams+='&vendor='+this.vendor

			this.urlRequestParams+='&branch='+this.branchid
			this.urlRequestParams+='&itemname='+this.itemname

			this.loading = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.reportdata = response.data;

					if(this.tabName=='sales_kemasan') {
						if(this.options?.branchlist?.length <= 0) {
							this.generateItemList()
							//this.generateStationList()
							this.generateBranchList()
						}
					}
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading = false;
				})
        },

		async loadStationListKemasan() {
			let url = Config().apiURL + "/fuel2/station-stock-kemasan?"
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.spbu.list = result.data.data;
				}
			})
		},

		getJobPosition() {
			this.urlRequestParams=Config().apiURL + '/vendor/job-position-tkjp?'
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{
				if(response.data.data){
					this.options.job = response.data.data;
				}
			})
			.catch(error => {
				//console.log(error)
				//console.log(error)
				//error.response.data
			})
			.finally(() => {

			})
		},

		getVendor() {
			this.urlRequestParams=Config().apiURL + '/vendor/vendor-tkjp?'
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{
				if(response.data.data){
					this.options.vendor = response.data.data;
				}
			})
			.catch(error => {
				//console.log(error)
				//error.response.data
			})
			.finally(() => {

			})
		},

		//FOR BBK KEMASAN
		generateBranchList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const branchKey = item.branchid //`${item.BranchID} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryName);
				} else {
					groupedData.push({
						branchKey,
						BranchID: item.branchid,
						BranchName: item.branchid
					});
				}
			});

			this.options.branchlist = groupedData
			//console.log('groupedData: ' + JSON.stringify(groupedData))

			//return groupedData;
		},
		generateItemList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const itemKey = item.itemname //`${item.BranchID} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.itemKey === itemKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryName);
				} else {
					groupedData.push({
						itemKey,
						ItemID: item.itemname,
						ItemName: item.itemname
					});
				}
			});

			this.options.itemlist = groupedData
			//console.log('itemlist: ' + JSON.stringify(groupedData))

			//return groupedData;
		},
		generateStationList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const itemKey = item.SPBUInduk //`${item.BranchID} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.itemKey === itemKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryName);
				} else {
					groupedData.push({
						itemKey,
						StationId: item.SPBUInduk,
						StationName: item.SPBUInduk
					});
				}
			});

			this.spbu.list = groupedData
			//console.log('groupedData: ' + JSON.stringify(groupedData))

			//return groupedData;
			//spbu.list
		},
		//END FOR BBK KEMASAN
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		async getSatgasDefaultConfig() {
			//GET SATGAS TITLE
			let url =Config().apiURL + '/v1/fuel2/satgastitle?'
			AxiosWithJar().get(url)
			.then((response) => {
				this.satgasDefaultConfig = response.data.data[0];
				this.date = [this.satgasDefaultConfig.START_DATE, this.satgasDefaultConfig.END_DATE];

				this.resumePilihan();
			})
		},

		exportExcel() {
			this.$refs["excelExport"].exportExcel();
			//console.log('export excel');
		},
		closeDropdownForm() {
			this.dropdownVisible = false;
		},
	},
	computed: {
		chartDataArea() {
			// Filter data for period 2024 and below
			return this.reportdata?.data?.filter(item => {
				const year = new Date(item.Period).getFullYear();
				return year <= 2024;
			});
		},
		chartDataRegion() {
			// Filter data for period 2025 and above
			return this.reportdata?.data?.filter(item => {
				const year = new Date(item.Period).getFullYear();
				return year > 2024;
			});
		},
        chartDataSalesAndStock() {
            return this.reportdata?.data?.flatMap(item => [
                {
                    Period: item.Period,
                    RegionPertareId: item.RegionPertareId,
                    MOR: item.MOR,
                    ProductName: item.ProductName,
                    ProductGroup: item.ProductGroup,
                    NumDays: item.NumDays,
                    Legend: "Sales Volume",
                    Volume: item.SalesVolume / 1000
                },
                {
                    Period: item.Period,
                    RegionPertareId: item.RegionPertareId,
                    MOR: item.MOR,
                    ProductName: item.ProductName,
                    ProductGroup: item.ProductGroup,
                    NumDays: item.NumDays,
                    Legend: "Stock Volume",
                    Volume: item.StockVolume / 1000
                }
            ]);
        },
	}
}
</script>
<style>
    .tabs .card-header{ padding-bottom:0px ;}
    .nav.nav-pills { background: rgba(20,109,182,.175) !important; border-radius: 10px 10px 0px 0px !important; padding: 0px !important; margin-top: 10px; }
    .nav.nav-pills .nav-link { color: #f8f9fa !important; border-radius: 5px 0px 0px 0px !important; background-color: none !important; margin-right: 10px !important; font-weight: 500; padding: 15px 20px; font-size: 0.875rem; }
    .nav.nav-pills .nav-link.active{ font-weight: bold; color: #f8f9fa  !important; background-color: transparent  !important;}
    .tab-pane.active { transition: all 0.5s ease-in-out; }
    .tab-pane.card-body { flex: 1 1 auto; padding: 0px 8px;  transition: all 0.5s ease-in-out;}
    .nav.nav-pills li.filter .nav-link{ position: absolute; right:0px; bottom: 0px; top: 0px; display: flex;
    align-items: center; }


.search.form { background:#f8f9fa; border-radius:0px 0px 5px 5px; color:#666; padding:20px; transition: all 0.5s ease-in-out;}
.search.form.minimize{ padding:0px; height:2px; overflow:hidden; }
.search.form.floating {
    position: fixed;
    right: 0px;
    bottom: 0px;
    width: 750px;
    height: 300px;
    z-index: 9;
    background: rgba(172,196,55,.75);
    padding: 20px;
    border-radius: 15px 15px 0px 15px;
    overflow-Y: scroll;
}

.table .card .card-header{ display:none;}
.table .card .card-body{ padding: 0px;}
.table.pdf{ border:0px; }
.table.pdf tr,.table.pdf td,.table.pdf th{ border:0px; }
.table.pdf tbody tr:nth-child(2n+2){ background:#f1f1f1; }

.table.pdf thead tr{ background: #ccc; color:#333;}

.filter .icon-up { display: flex; }
.filter.down .icon-up { display: none; }
.filter .icon-down { display: none; }
.filter.down .icon-down { display: flex; }


.dropdown-filter-form {
	padding:20px;
	max-height: 320px;
	overflow: auto;
}

.dropdown-filter {
	margin:10px !important;
	padding: 8px 0px !important;
	min-width: 60% !important;
}

@media (min-width: 768px) {
	.dropdown-filter {
		margin:10px;
		max-width:70%;
	}
}

@media (min-width: 320px) {
	.dropdown-filter {
		margin:10px;
	}
}
</style>
